const CONTACT_TYPES = {
	phone: {
		link: phone => 'tel:' + phone,
		icon: 'icon-phone',
		label: 'Phone',
		placeholder: 'Enter a phone number'
	},
	website: {
		link: link => (link.indexOf('://') === -1 ? 'https://' + link : link),
		icon: 'icon-public',
		label: 'Website',
		placeholder: 'Enter a website link (e.g. www.google.com)'
	},
	email: {
		link: mail => 'mailto:' + mail,
		icon: 'icon-mail_outline',
		label: 'Email',
		placeholder: 'Enter an email address (e.g. bob@b2me.com.au)'
	},
	facebook: {
		link: link => (link.indexOf('facebook.com') === -1 ? 'https://www.facebook.com/' + link : link),
		icon: 'icon-facebook2',
		label: 'Facebook',
		placeholder: 'Your Facebook profile',
		prefix: 'https://www.facebook.com/',
		prefixMatcher: new RegExp('((https|http)?://)?(www\\.)?facebook\\.com'),
		explanation: 'e.g. https://www.facebook.com/B2MeAustralia/'
	},
	twitter: {
		link: link => (link.indexOf('twitter.com') === -1 ? 'https://twitter.com/' + link : link),
		label: 'Twitter',
		placeholder: 'Your Twitter profile',
		prefix: 'https://twitter.com/',
		prefixMatcher: new RegExp('((https|http)?://)?(www\\.)?twitter\\.com'),
		explanation: 'e.g. https://twitter.com/B2MeAustralia'
	},
	instagram: {
		link: link =>
			link.indexOf('instagram.com') === -1 ? 'https://www.instagram.com/' + link : link,
		label: 'Instagram',
		placeholder: 'Your Instagram profile',
		prefix: 'https://www.instgram.com/',
		prefixMatcher: new RegExp('((https|http)?://)?(www\\.)?instagram\\.com'),
		explanation: 'e.g. https://www.instagram.com/b2meaustralia/'
	},
	pinterest: {
		link: link =>
			link.indexOf('pinterest.com') === -1 ? 'https://www.pinterest.com/' + link : link,
		label: 'Pinterest',
		placeholder: 'Your Pinterest profile',
		prefix: 'https://www.pinterest.com/',
		prefixMatcher: new RegExp('((https|http)?://)?(www\\.)?pinterest\\.com'),
		explanation: 'e.g. https://www.pinterest.com/bob.b2me'
	},
	linkedin: {
		link: link => (link.indexOf('linkedin.com') === -1 ? 'https://linkedin.com/in/' + link : link),
		label: 'LinkedIn',
		placeholder: 'Your LinkedIn profile',
		prefix: 'https://www.linkedin.com/in/',
		prefixMatcher: new RegExp('((https|http)?://)?(www\\.)?linkedin\\.com'),
		explanation: 'e.g. https://www.linkedin.com/in/b2me/'
	},
	skype: {
		label: 'Skype',
		placeholder: 'Enter your Skype name (e.g. bob.b2me)'
	}
};

export const contactTypeToIconName = type =>
	CONTACT_TYPES[type] && CONTACT_TYPES[type].icon ? CONTACT_TYPES[type].icon : 'icon-' + type;

export const contactToLink = ({type, detail}) =>
	CONTACT_TYPES[type] && CONTACT_TYPES[type].link ? CONTACT_TYPES[type].link(detail) : detail;

export const getTypeLabel = type => CONTACT_TYPES[type] && CONTACT_TYPES[type].label;

export const getTypePlaceholder = type => CONTACT_TYPES[type] && CONTACT_TYPES[type].placeholder;

export const getTypePrefix = type => CONTACT_TYPES[type] && CONTACT_TYPES[type].prefix;

export const getTypeExplanation = type => CONTACT_TYPES[type] && CONTACT_TYPES[type].explanation;

export const getTypes = () => Object.keys(CONTACT_TYPES);

export const isPrefixed = (type, value) =>
	!!(
		value &&
		CONTACT_TYPES[type] &&
		CONTACT_TYPES[type].prefixMatcher &&
		CONTACT_TYPES[type].prefixMatcher.test(value)
	);



// WEBPACK FOOTER //
// ./src/contactHelper.js